import { Palette } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/providers/ThemeProvider";
import type { ColorTheme } from "@/providers/ThemeProvider";

const colorThemes: ColorTheme[] = [
  "flowstate-blue",
  "purple-edge",
  "emerald",
  "amber",
  "rose",
];

const colorLabels: Record<ColorTheme, string> = {
  "flowstate-blue": "FlowState Blue",
  "purple-edge": "Purple Edge",
  emerald: "Emerald",
  amber: "Amber",
  rose: "Rose",
};

export function ColorThemeToggle() {
  const { colorTheme, setColorTheme } = useTheme();

  const cycle = () => {
    const idx = colorThemes.indexOf(colorTheme);
    const next = colorThemes[(idx + 1) % colorThemes.length];
    setColorTheme(next);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycle}
      title={`Color theme: ${colorLabels[colorTheme]}`}
      aria-label={`Cycle color theme, current: ${colorLabels[colorTheme]}`}
      className="text-foreground hover:text-primary"
    >
      <Palette className="h-5 w-5" />
      <span className="sr-only">Cycle color theme</span>
    </Button>
  );
}
